import React, { forwardRef } from "react";
import { P, SectionMainWrapper, SectionSubHeading } from "../../Styles/style";
import mainimg from "../../../assets/images/mainimg.png"
import { Container, Grid, useTheme } from "@mui/material";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { GridHEading, GridImage, JOiningLinks, BuyNow, SectionHeading, SectionHeadingPer, MainWrapper, CircleWrapper, TextInCircle, DownloadLink, Div, PayDiv, Ca, } from "./styles";
import styled from "@emotion/styled";

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const Otcimg = styled.img`
width:100%;
height:auto;
max-width:430px;
  position:absolute;
  top:22%;
  left:36%;
  @media screen and (min-width:1800px){
    left:40%;
  }
  @media screen and (max-width:1300px){
    left:33%;
  }
  @media screen and (max-width:1200px){
    left:31%;
  }
  @media screen and (max-width:900px){
    position:UNSET;
  }
`
const DIV = styled.div`
  height:230px;
  
  @media screen and (max-width:900px){
    height:UNSET;
  }
`
const Section1_Header = () => {
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };
  const theme = useTheme()
  return (
    <>
      <div >
        <SectionMainWrapper p="6rem 0" id="home" align="center">
          <Container maxWidth="xl">
            <SectionHeading p599="0" p="0 0" m="0" data-aos="flip-up" data-aos-easing="ease-in" data-aos-delay="400" data-aos-duration="600" data-aos-offset="0">
              Pulse OTC
            </SectionHeading>
            <DIV></DIV>
            <Otcimg data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="200"
                data-aos-duration="600"
                data-aos-offset="0" src={mainimg} />
            <SectionSubHeading p="0" m="0" align="center" data-aos="flip-up" data-aos-easing="ease-in" data-aos-delay="400" data-aos-duration="600" data-aos-offset="0">
              Buy $Pulse With $ETH
            </SectionSubHeading>
            <Grid container>
              <Grid item xs={12} md={3}></Grid>
              <Grid item xs={12} md={6}>
                <P p="20px 0 40px" m="0" align="center" data-aos="flip-up" data-aos-easing="ease-in" data-aos-delay="500" data-aos-duration="500" data-aos-offset="0" >
                  Been wanting to get your hands on some $Pulse but can't find any reliable outlets?
                  You don't need to look around any more, with PULSE OTC you can easily swap out your Ethereum for $Pulse on the Pulse network.</P>
                <div data-aos="flip-up" data-aos-easing="ease-in" data-aos-delay="700" data-aos-duration="500" data-aos-offset="0" >
                  <BuyNow hoverbgColor={theme.pageColor} bgColor={theme.bgTertiary} onClick={handleClick}><span /><span /><span /><span />Buy Now</BuyNow>
                  <BuyNow bgColor={theme.pageColor} brColor={theme.textPrimary} onClick={handleClick}
                  // href="/" // target="_blank"
                  >
                    View Chart
                  </BuyNow>
                </div>
              </Grid>
              <Grid item xs={12} md={3}></Grid>

            </Grid>

            {/* <div>
                <SectionSubHeading color={theme.textTertiary} p="40px 0 20px"
                  align="center"
                  data-aos="flip-up"
                  data-aos-easing="ease-in"
                  data-aos-delay="800"
                  data-aos-duration="400"
                  data-aos-offset="0">View Us On</SectionSubHeading>
                <PayDiv>
                  <a href="#"
                    data-aos="zoom-in-up"
                    data-aos-easing="ease-in"
                    data-aos-delay="900"
                    data-aos-duration="500"
                    data-aos-offset="0">
                      
                    <JOiningLinks src={metamask} />
                  </a>
                  <a href="#" data-aos="zoom-in-up"
                    data-aos-easing="ease-in"
                    data-aos-delay="1000"
                    data-aos-duration="500"
                    data-aos-offset="0">
                      
                    <JOiningLinks src={arbscan} />
                  </a>

                  <P p="0" m="0" data-aos="zoom-in-up"
                    data-aos-easing="ease-in"
                    data-aos-delay="1200"
                    data-aos-duration="500"
                    data-aos-offset="0">
                    and many more..
                  </P>
                </PayDiv>
              </div> */}
          </Container>
        </SectionMainWrapper>

      </div>

    </>
  );
};

export default Section1_Header;
